import React, { useEffect, useState } from "react";
import MaterialButton from "@mui/material/Button";
import { Box, Typography, Breadcrumbs, Tabs, Tab } from "@mui/material";
import { useAtom } from "jotai";
import { useNavigate, useParams } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import Loader from "../../../components/super-admin/common/Loader";
import TeamInfoCard from "../../../components/super-admin/team/TeamInfoCard";
import TeamUserTable from "../../../components/super-admin/team/teamUserInfoTab/TeamUserTable";
import { SAdminBaseAtom } from "../../../stores/jotai/super-admin/superAdminBase";
import { useGetGroupDetails } from "../../../tanstackQuery/queries/superAdmin/group";
import { useQueryClient } from "@tanstack/react-query";
import { findParent } from "../../../stores/jotai/base";


const ManageTeam = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [sAdminBase,]=useAtom(SAdminBaseAtom);
  const { cohortID, teamID } = useParams();
  const { keycloak } = useKeycloak();
  const navigate = useNavigate();
  const orgID = sAdminBase?.selectedOrg.orgID
  const orgName = sAdminBase?.selectedOrg?.name;
  const teamName = sAdminBase?.selectedGroup?.group?.name
  const cohortName =  sAdminBase?.selectedCohort?.group?.name
  const client = useQueryClient();

  const orgTreeData = client.getQueryData([
    "orgtree",
    { orgID: sAdminBase?.selectedOrg?.orgID }
  ]) as any;
  const folderName =orgTreeData?.hierarchy? findParent(sAdminBase?.selectedCohort?.childID,orgTreeData?.hierarchy):null;
  const teamApiDataParams = {
    orgID,
    cohortID,
    teamID,
  };

  const {
    data: teamData,
    isLoading: isTeamLoading,
    refetch,
  } = useGetGroupDetails(
    { accessToken: keycloak?.token },
    {
      groupID: teamID,
      groupType: "Team",
    },
    { enabled: !!(keycloak?.token && teamID) }
  );
  useEffect(() => {
    refetch();
  }, [cohortID, teamID, refetch]);

  const handleTabChange = (event, newIndex) => {
    setActiveTab(newIndex);
  };
  if (isTeamLoading) {
    return <Loader />;
  }
  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: "bold", paddingLeft: "6px" }}>
        Team Details: {teamData?.name}
      </Typography>
      <Box style={{ paddingLeft: 6 }}>
        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{ backgroundColor: "#f4f4f4" }}
        >
          <Typography color="inherit">{orgName}</Typography>
          {folderName?.group?.name && (
            <Typography color="inherit">{folderName?.group?.name}</Typography>
          )}
          {cohortName && <Typography color="inherit">{cohortName}</Typography>}
          {teamName && <Typography color="inherit">{teamName}</Typography>}
        </Breadcrumbs>
        <Box style={{ paddingTop: 10 }}>
          <MaterialButton variant="contained" onClick={() => navigate(-1)}>
            Return
          </MaterialButton>
        </Box>
      </Box>

      <TeamInfoCard teamDetails={teamData} teamApiDataParams={teamApiDataParams}/>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        sx={{ mb: 2, display: "flex", gap: 5 }}
      >
        <Tab value={0} label="User List" />
      </Tabs>
      {activeTab === 0 && (
        <TeamUserTable teamUserDetailsParam={teamApiDataParams} />
      )}
    </Box>
  );
};

export default ManageTeam;
